import React, { useEffect, useState } from 'react';
import './saude.css';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import SearchInternal from '../../components/SearchInternal/SearchInternal';
import InternalPhoto from '../../components/InternalPhoto';
import { useInternals } from '../../context/internalContext';
import { useLocation } from 'react-router-dom';
import { useUsers } from '../../context/usersContext';
import InternalDataSkeleton from '../../components/InternalDataSkeleton';

const DoencasCronicas = () => {
  const location = useLocation();
  const { internalId } = location.state || {};
  const { listInternals } = useInternals();
  const { buildUnitReadParams } = useUsers();
  const [internalDetails, setInternalDetails] = useState(null);
  const [isSelectingInternal, setIsSelectingInternal] = useState(false);

  const formatValue = (value) => {
    if (!value) return '';
    if (Array.isArray(value)) return value.filter(Boolean).join(', ');
    return value;
  };

  const handleInternalSelect = (internal) => {
    setInternalDetails(internal);
  };

  useEffect(() => {
    if (internalId) {
      (async () => {
        try {
          const response = await listInternals(buildUnitReadParams({ id: internalId }));
          const internal = response?.results?.[0];
          if (internal) setInternalDetails(internal);
        } catch (err) {
          console.error('Erro ao carregar interno:', err);
        }
      })();
    }
  }, [internalId, listInternals, buildUnitReadParams]);

  return (
    <div>
      <Sidebar />
      <Header />
      <div className='container social-container'>
        <Titulo
          children={
            <SearchInternal
              onSelect={handleInternalSelect}
              onSelectingChange={setIsSelectingInternal}
            />
          }
          children2={<button type="button" className="social-submit-button">Enviar</button>}
        />

        <h4 className='h4-title'>Portadores de Doenças Crônicas</h4>
        {isSelectingInternal ? (
          <InternalDataSkeleton />
        ) : (
        <div className='content-topo'>
          <div className='content-img'>
            <InternalPhoto internal={internalDetails} alt={internalDetails?.name || 'Foto interno'} />
          </div>

          <div className='content-itens'>
            <div>
              <p><strong>Nome:</strong> {formatValue(internalDetails?.name)}</p>
              <p><strong>Nome Social:</strong> {formatValue(internalDetails?.social_name)}</p>
              <p><strong>Vulgo:</strong> {formatValue(internalDetails?.aka)}</p>
              <p><strong>CPF:</strong> {formatValue(internalDetails?.cpf)}</p>
            </div>
            <div>
              <p><strong>Unidade:</strong> {formatValue(internalDetails?.unit_acronym)}</p>
              <p><strong>Pavilhão:</strong> {formatValue(internalDetails?.pavilion_name)}</p>
              <p><strong>Cela:</strong> {formatValue(internalDetails?.cell_name)}</p>
              <p><strong>Conduta:</strong> {formatValue(internalDetails?.conduct?.name)}</p>
            </div>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default DoencasCronicas;
